import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "direction" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M18.6275 3.1237L4.01017 9.87021C2.32371 10.6574 2.88586 13.131 4.68482 13.131H10.8692V19.3153C10.8692 21.1143 13.3428 21.6768 14.1299 19.99L20.8764 5.37265C21.4386 4.023 19.9768 2.5612 18.6275 3.1237V3.1237Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }